module.exports = __webpack_public_path__ + "img/face-eyes-xmarks.359cc6f5.svg";